var render = function (_h,_vm) {var _c=_vm._c;return _c('section',_vm._g(_vm._b({ref:_vm.data.ref,staticClass:"section",class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle])},'section',_vm.data.attrs,false),_vm.listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }